function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ProGallery from '../proGallery/proGallery';
import LAYOUTS from '../../../common/constants/layout';
import { featureManager } from '../../helpers/versionsHelper';
import SCROLL_DIRECTION from '../../../common/constants/scrollDirection';
export var fixedStyles = {
  galleryLayout: LAYOUTS.MAGIC,
  cubeImages: undefined,
  cubeRatio: undefined,
  isVertical: undefined,
  gallerySize: undefined,
  collageAmount: undefined,
  collageDensity: undefined,
  groupTypes: undefined,
  oneRow: undefined,
  // later on in layoutHelper this can be changed if it is false, so not exactly fixed.
  imageMargin: undefined,
  floatingImages: undefined,
  galleryMargin: undefined,
  chooseBestGroup: undefined,
  smartCrop: undefined,
  cubeType: undefined,
  hasThumbnails: undefined,
  enableScroll: undefined,
  isGrid: undefined,
  isSlideshow: undefined,
  isSlider: undefined,
  isColumns: undefined,
  cropOnlyFill: undefined,
  fixedColumns: undefined,
  enableInfiniteScroll: undefined
};

var getStyleBySeed = function getStyleBySeed(seed) {
  if (!seed > 0) {
    seed = 999999;
  }

  seed = Math.floor(seed);

  var strToSeed = function strToSeed(str) {
    str = String(str);
    var total = 0;

    for (var s = 0; s < str.length; s++) {
      total += str.charCodeAt(s);
    }

    return total;
  };

  var mergeSeeds = function mergeSeeds(s1, s2) {
    return Math.floor((s1 / s2 - Math.floor(s1 / s2)) * 10000000);
  };

  var numFromSeed = function numFromSeed(min, max, strSeed) {
    var seed2 = strToSeed(strSeed);
    var range = max - min + 1;
    return mergeSeeds(seed, seed2) % range + min;
  };

  var boolFromSeed = function boolFromSeed(strSeed) {
    return !!numFromSeed(0, 1, strSeed);
  };

  var style = {
    cubeImages: boolFromSeed('cubeImages'),
    cubeRatio: numFromSeed(1, 25, 'cubeRatio') / 5,
    isVertical: boolFromSeed('isVertical'),
    gallerySize: numFromSeed(300, 800, 'gallerySize'),
    collageAmount: numFromSeed(5, 10, 'collageAmount') / 10,
    collageDensity: (featureManager.supports.spacingCalculation ? numFromSeed(1, 100, 'collageDensity') : numFromSeed(5, 10, 'collageDensity')) / 100,
    groupTypes: ['1'].concat('2h,2v,3t,3b,3l,3r,3h,3v'.split(',').filter(function (type, i) {
      return boolFromSeed('groupTypes' + i);
    })),
    oneRow: boolFromSeed('oneRow'),
    imageMargin: numFromSeed(0, featureManager.supports.spacingCalculation ? numFromSeed(300, 800, 'gallerySize') / 5 : 5, 'imageMargin'),
    galleryMargin: featureManager.supports.spacingCalculation ? 0 : numFromSeed(0, 5, 'imageMargin'),
    floatingImages: 0,
    chooseBestGroup: boolFromSeed('chooseBestGroup'),
    smartCrop: boolFromSeed('smartCrop'),
    cubeType: 'fill',
    enableScroll: true,
    isGrid: false,
    isSlideshow: false,
    isSlider: false,
    isColumns: false,
    cropOnlyFill: false,
    fixedColumns: 0,
    enableInfiniteScroll: 1
  }; //force adjustments

  if (style.oneRow) {
    style.isVertical = false;
    style.scrollDirection = SCROLL_DIRECTION.HORIZONTAL;
  } else {
    style.scrollDirection = SCROLL_DIRECTION.VERTICAL;
  }

  style.galleryType = style.isVertical ? 'Columns' : 'Strips';
  style.groupSize = parseInt(style.groupTypes.slice(-1)[0]);
  style.groupTypes = style.groupTypes.join(',');
  style.minItemSize = style.gallerySize / style.groupSize / 2;
  return style;
};

export var createStyles = function createStyles(styles) {
  return _objectSpread(_objectSpread(_objectSpread({}, styles), fixedStyles), getStyleBySeed(styles.magicLayoutSeed));
};

var MagicGallery = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MagicGallery, _React$Component);

  function MagicGallery() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MagicGallery.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(ProGallery, _extends({}, this.props, {
      styles: createStyles(this.props.styles)
    }));
  };

  return MagicGallery;
}(React.Component);

export { MagicGallery as default };